// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__SMX5_","dragIcon":"SortableItem_dragIcon__1MJkG","disabled":"SortableItem_disabled__2mzL5"};